<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "CompanyOmsAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  